var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_75655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0788 20.125C23.5743 20.125 21.4287 22.3529 21.4287 25.1905C21.4287 28.0281 23.5743 30.256 26.0788 30.256C28.5833 30.256 30.7289 28.0281 30.7289 25.1905C30.7289 22.3529 28.5833 20.125 26.0788 20.125ZM19.9287 25.1905C19.9287 21.6311 22.6432 18.625 26.0788 18.625C29.5144 18.625 32.2289 21.6311 32.2289 25.1905C32.2289 28.7499 29.5144 31.756 26.0788 31.756C22.6432 31.756 19.9287 28.7499 19.9287 25.1905Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5786 34.3247C21.0798 33.2207 24.084 32.6562 26.1693 32.6562C28.2546 32.6562 31.2587 33.2207 33.7599 34.3247C35.0125 34.8777 36.183 35.5849 37.0507 36.4629C37.9247 37.3474 38.5231 38.441 38.5231 39.7304V47.0928C38.5231 47.507 38.1873 47.8428 37.7731 47.8428C37.3589 47.8428 37.0231 47.507 37.0231 47.0928V39.7304C37.0231 38.9432 36.6663 38.208 35.9837 37.5173C35.2948 36.8202 34.3073 36.206 33.1542 35.697C30.844 34.6773 28.0462 34.1562 26.1693 34.1562C24.2923 34.1562 21.4945 34.6773 19.1844 35.697C18.0313 36.206 17.0437 36.8202 16.3548 37.5173C15.6722 38.208 15.3154 38.9432 15.3154 39.7304V47.0928C15.3154 47.507 14.9796 47.8428 14.5654 47.8428C14.1512 47.8428 13.8154 47.507 13.8154 47.0928V39.7304C13.8154 38.441 14.4138 37.3474 15.2879 36.4629C16.1556 35.5849 17.326 34.8777 18.5786 34.3247Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4912 41.0547C32.9054 41.0547 33.2412 41.3905 33.2412 41.8047V47.0905C33.2412 47.5048 32.9054 47.8405 32.4912 47.8405C32.077 47.8405 31.7412 47.5048 31.7412 47.0905V41.8047C31.7412 41.3905 32.077 41.0547 32.4912 41.0547Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8545 41.0547C20.2687 41.0547 20.6045 41.3905 20.6045 41.8047V47.0905C20.6045 47.5048 20.2687 47.8405 19.8545 47.8405C19.4403 47.8405 19.1045 47.5048 19.1045 47.0905V41.8047C19.1045 41.3905 19.4403 41.0547 19.8545 41.0547Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6084 47.1016C10.6084 46.6873 10.9442 46.3516 11.3584 46.3516H40.8868C41.301 46.3516 41.6368 46.6873 41.6368 47.1016C41.6368 47.5158 41.301 47.8516 40.8868 47.8516H11.3584C10.9442 47.8516 10.6084 47.5158 10.6084 47.1016Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45215 47.1016C6.45215 46.6873 6.78793 46.3516 7.20215 46.3516H9.27764C9.69185 46.3516 10.0276 46.6873 10.0276 47.1016C10.0276 47.5158 9.69185 47.8516 9.27764 47.8516H7.20215C6.78793 47.8516 6.45215 47.5158 6.45215 47.1016Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21387 47.1016C2.21387 46.6873 2.54965 46.3516 2.96387 46.3516H5.03935C5.45356 46.3516 5.78935 46.6873 5.78935 47.1016C5.78935 47.5158 5.45356 47.8516 5.03935 47.8516H2.96387C2.54965 47.8516 2.21387 47.5158 2.21387 47.1016Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3076 47.1016C42.3076 46.6873 42.6434 46.3516 43.0576 46.3516H45.1331C45.5473 46.3516 45.8831 46.6873 45.8831 47.1016C45.8831 47.5158 45.5473 47.8516 45.1331 47.8516H43.0576C42.6434 47.8516 42.3076 47.5158 42.3076 47.1016Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71925 1.84766C3.41622 1.84766 2.31934 2.91531 2.31934 4.28079V22.0688C2.31934 23.4198 3.40156 24.5019 4.81469 24.5019H6.91464C7.14434 24.5019 7.36138 24.6072 7.5036 24.7876L13.0225 31.7873C13.1475 31.9179 13.3033 31.9391 13.4228 31.9C13.4842 31.88 13.5285 31.8463 13.5566 31.809C13.5817 31.7756 13.6099 31.7188 13.6099 31.6182V25.2519C13.6099 24.8377 13.9457 24.5019 14.3599 24.5019H17.6052C18.0195 24.5019 18.3552 24.8377 18.3552 25.2519C18.3552 25.6661 18.0195 26.0019 17.6052 26.0019H15.1099V31.6182C15.1099 32.4799 14.5692 33.1034 13.889 33.3258C13.2249 33.5429 12.4325 33.3796 11.8912 32.7728C11.8811 32.7615 11.8713 32.7498 11.8619 32.7379L6.5509 26.0019H4.81469C2.60065 26.0019 0.819336 24.2755 0.819336 22.0688V4.28079C0.819336 2.08866 2.58601 0.347656 4.71925 0.347656H43.1863C45.4004 0.347656 47.1817 2.07415 47.1817 4.28079V22.0688C47.1817 24.2755 45.4004 26.0019 43.1863 26.0019H34.6911C34.2769 26.0019 33.9411 25.6661 33.9411 25.2519C33.9411 24.8377 34.2769 24.5019 34.6911 24.5019H43.1863C44.5995 24.5019 45.6817 23.4198 45.6817 22.0688V4.28079C45.6817 2.92982 44.5994 1.84766 43.1863 1.84766H4.71925Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7803 12.7305C14.7803 12.3163 15.1161 11.9805 15.5303 11.9805H18.8534C19.2676 11.9805 19.6034 12.3163 19.6034 12.7305C19.6034 13.1447 19.2676 13.4805 18.8534 13.4805H15.5303C15.1161 13.4805 14.7803 13.1447 14.7803 12.7305Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 12.7305C21.25 12.3163 21.5858 11.9805 22 11.9805H25.3231C25.7373 11.9805 26.0731 12.3163 26.0731 12.7305C26.0731 13.1447 25.7373 13.4805 25.3231 13.4805H22C21.5858 13.4805 21.25 13.1447 21.25 12.7305Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7197 12.7305C27.7197 12.3163 28.0555 11.9805 28.4697 11.9805H31.7929C32.2071 11.9805 32.5429 12.3163 32.5429 12.7305C32.5429 13.1447 32.2071 13.4805 31.7929 13.4805H28.4697C28.0555 13.4805 27.7197 13.1447 27.7197 12.7305Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_75655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.0976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.6a463dd7.svg";
export { ForwardRef as ReactComponent };